import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { featuresCards } from 'sections/Benefits/MemberDirectory/data';
import styles from 'sections/Benefits/MemberDirectory/components/SectionFeatures/SectionFeatures.module.scss';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  const cardsList = featuresCards.map((card) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/Benefits/MemberDirectory/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('features')}>
      <img
        className={cn('features__bg-cloud')}
        src='/images/pages/Benefits/MemberDirectory/bg-cloud.webp'
        alt='background effect'
      />
      <div className={cn('container')}>
        <div className={cn('features__title-box')}>
          <h2 className={cn('features__title')}>
            Why Use Our Freight Forwarders Directory List?
          </h2>
        </div>
        <ul className={cn('features__list')}>
          {cardsList}
        </ul>
      </div>
    </section>
  );
};

export default SectionFeatures;